import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { Box, Container, Skeleton } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import YouTube from 'react-youtube';
import { useDevice } from '../../../hooks/useResponsive';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export default function ProductSingleYoutubeShort({ youtubeId }) {
  const { isMobile } = useDevice();
  const [isLoading, setIsLoading] = useState(true);

  // console.log(youtubeId)
  const opts = {
    width: isMobile ? '220px' : '220px',
    height: isMobile ? '420px' : '420px',
    playerVars: {
      autoplay: 0,
    },
  };

  return (
    <div>
      <StyledRoot sx={{ marginBottom: 0 }}>
        {isMobile ? (
          <Container
            className=""
            maxWidth="lg"
            sx={{
              paddingTop: { xs: '0', sm: '0px' },
              // paddingBottom: { xs: '0', sm: '125px' },
              paddingLeft: { xs: '0', sm: '16px' },
              paddingRight: { xs: '0', sm: '16px' },
            }}
          >
            {/* <Grid container direction="row" className="bg-color"> */}

            <Box
              className="react-player react-player-single-product "
              sx={{ position: 'relative', borderRadius: '16px' }}
            >
              <YouTube
                videoId={youtubeId}
                // id={'https://youtu.be/HGgWfjQ9ZeQ?si=qFF6ZrHjJhoXGHEZ'}
                opts={opts}
                className="react-player-shorts-video rounded"
                iframeClassName={isMobile && 'w-100'}
                onReady={() => setIsLoading(false)}

                // className={string}
                // style={object}
                // title={string}
                // loading={string}
                // onReady={func}
                // onPlay={func}
                // onPause={func}
                // onEnd={func}
                // onError={func}
                // onStateChange={func}
                // onPlaybackRateChange={func}
                // onPlaybackQualityChange={func}
              />
              {/* <div className="prod-div prod-div-utube" /> */}
              {isLoading && (
                <Skeleton
                  variant="rectangular"
                  animation="wave"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: isMobile ? '220px' : '220px',
                    height: isMobile ? '100%' : '100%',
                    borderRadius: 2,
                    zIndex: 1,
                  }}
                />
              )}
            </Box>
            {/* </Grid> */}
          </Container>
        ) : (
          <Box
            className="react-player react-player-single-product "
            sx={{ width: '100%', position: 'relative', borderRadius: '16px' }}
          >
            <YouTube
              videoId={youtubeId}
              // id={'https://youtu.be/HGgWfjQ9ZeQ?si=qFF6ZrHjJhoXGHEZ'}
              opts={opts}
              className="react-player-shorts-video rounded"
              iframeClassName={isMobile && 'w-100'}
              onReady={() => setIsLoading(false)}

              // className={string}
              // style={object}
              // title={string}
              // loading={string}
              // onReady={func}
              // onPlay={func}
              // onPause={func}
              // onEnd={func}
              // onError={func}
              // onStateChange={func}
              // onPlaybackRateChange={func}
              // onPlaybackQualityChange={func}
            />
            {isLoading && (
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: isMobile ? '220px' : '220px',
                  height: isMobile ? '218%' : '100%',
                  borderRadius: 2,
                  zIndex: 1,
                }}
              />
            )}
            {/* <div className="prod-div prod-div-utube" /> */}
          </Box>
        )}
      </StyledRoot>
    </div>
  );
}
ProductSingleYoutubeShort.propTypes = {
  youtubeId: PropTypes.any,
};
